/* eslint-disable ember/no-computed-properties-in-native-classes */
import { inject as controller } from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import DayDetailControllerBaseController from 'lumen/controllers/day-detail-controller-base';
import { RATE_PARAMS } from 'lumen/utils/constants/general-constants';
import isRatesAvailable from 'lumen/utils/revenue-insight/rates-data-checks';

export default class HotelRevenueInsightDetailController extends DayDetailControllerBaseController {
  @service('hotel-and-market') hotelAndMarketService;
  @service riSelections;
  @service router;
  @service store;

  // Parent controller
  @controller('hotel.revenue-insight') parentController;

  @computed('hotelAndMarketService.hotelOrMarket')
  get hotel() {
    return this.hotelAndMarketService.hotelOrMarket;
  }

  @computed(
    'hotelAndMarketService.hotel.OTAsRates.@each.isConnectedOrBrandDotCom',
  )
  get otaId() {
    return this.hotelAndMarketService.hotel?.OTAsRates?.filter(
      (ota) => ota.isConnectedOrBrandDotCom,
    )?.[0]?.id;
  }

  get ratesEvolutionDisabled() {
    return !isRatesAvailable(
      this.parentController?.fromDate,
      this.parentController?.toDate,
      this.hotelAndMarketService,
      this.parentController?.segmentationFilters,
      this.parentController?.stayDateFilter,
      this.parentController?.kpi,
      this.parentController?.kpiCategory,
    );
  }

  get ratesParams() {
    return {
      los: this.hotel?.defaultLosRates?.[0],
      persons: 2,
      ota: this.otaId,
      rateParam: RATE_PARAMS.BEST_FLEX,
    };
  }

  get selectedOTA() {
    // In some cases (like RI without rates) this bit crashes without checking if there is an OTA id
    if (this.otaId) {
      return this.store.peekRecord('ota', this.otaId);
    }

    return null;
  }

  @action
  redirect() {
    this.router.legacyTransitionTo('hotel.revenue-insight');
  }
}
